export const ACCOUNT_TABS = {
  overview: "overview",
  orderHistory: "orderHistory",
  favourites: "favourites",
  wishlist: "wishlist",
  accountSettings: "details",
  signOut: "signOut",
} as const;
